import { IAnalyteInCup } from "./cup.interface";

export interface UDTResult {
	_id?: string;
	week: number;
	visitNumber: number;
	visitDate: Date;
	result: string;
	notes: string;
	excusedAbsenceNotes?: string;
	providerId: string;
	amountEarned?: number;
}

/**
 * Nested data structure for Cups and Analytes
 * Groups all cups/analytes related fields into a single optional property
 */
export interface CupsAndAnalytesData {
	cupId: string;
	cupName?: string;
	// All analytes with their checked/unchecked state
	analytes?: {
		primary?: { [analyteId: string]: boolean };
		secondary?: { [analyteId: string]: boolean };
	};
	// Selected analyte objects for display (used in summary screen)
	selectedPrimaryAnalytes?: IAnalyteInCup[];
	selectedSecondaryAnalytes?: IAnalyteInCup[];
	isTampered?: boolean;
	tamperedReasons?: string[];
}

export interface UDTResultCashOut extends UDTResult {
	isbankIncentive: boolean;
	productId: string;
	productName: string;
	delivery: string;
	deliveryValue?: string;
	udtResultId?: string;
	incentiveType?: "GC" | "PPC";
	treatmentConfigName?: string; // Activity name to identify which treatment config to use
	providerSiteId?: string;
	calculatedVisitNumber?: number;
	// Cups and Analytes - grouped into a single optional property
	cupsAndAnalytes?: CupsAndAnalytesData;
}

export enum EnrollmentStatus {
	ACTIVE = "ACTIVE",
	COMPLETED = "COMPLETED",
	DISENROLLED = "DISENROLLED",
	PAUSED = "PAUSED",
}

export interface UDTResultEdit {
	week: number;
	visitNumber: number;
	providerId: string;
	result: string;
	notes: string;
	isbankIncentive: boolean;
	delivery: string;
	productId: string;
	productName: string;
	udtId: string;
	incentiveType?: "GC" | "PPC";
}

// Cups and Analytes UDT Result interfaces for backend-2
export interface UDTResultWithCupsAnalytes extends UDTResult {
	isbankIncentive: boolean;
	productId: string;
	productName: string;
	delivery: string;
	deliveryValue?: string;
	udtResultId?: string;
	incentiveType?: "GC" | "PPC";
	treatmentConfigName?: string;
	providerSiteId?: string;
	// Cups and Analytes - grouped into a single optional property
	cupsAndAnalytes?: CupsAndAnalytesData;
}

export interface UDTResultEditWithCupsAnalytes extends UDTResultEdit {
	providerSiteId?: string;
	calculatedVisitNumber?: number;
	// Cups and Analytes - grouped into a single optional property
	cupsAndAnalytes?: CupsAndAnalytesData;
}

export interface BankRedeemRequest {
	providerId: string;
	delivery: string;
	productId: string;
	productName: string;
}

export interface ConfirmExcusedAbsenceRequest {
	excusedAbsenceNotes: string;
	changeToUnexcused: boolean;
}

export interface ConfirmExcusedAbsenceResponse {
	enrollmentId: string;
	udtResult: {
		udtResultId: string;
		visitDate: string;
		visitNumber: number;
		weekNumber: number;
		notes: string;
		excusedAbsenceNotes: string;
	};
}

export interface UpdateEnrollmentPayerPlanRequest {
	payerPlan: {
		payerId: string;
		memberIdNumber: string;
	};
	isNewPayerPlan?: boolean;
	changedBy?: string;
}
